import {
  CommonAskDescriptors,
  CommonTellDescriptors,
  ShellBridge,
  TellApi,
} from '@qualifio/qualifio-shell';

export function isInShell(): boolean {
  // window.parent may be replaced by window.self when performing cypress tests
  // using window['parent'] avoids the issue
  return window.location !== window['parent'].location;
}

export const bridge = new ShellBridge<LoyaltyTellDescriptors, CommonAskDescriptors>({
  debug: true,
  appName: 'loyalty',
});

export type Navigation = {
  path: string;
};

export type LoyaltyTellDescriptors = CommonTellDescriptors & {
  navigation: TellApi<Navigation>;
};
